/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Gramáž`
};

const da_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Grammage`
};

const de_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Flächengewicht`
};

const en_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Grammage`
};

const es_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `gramaje`
};

const fr_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Grammage`
};

const hu_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Grammage`
};

const it_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Grammatura`
};

const nl_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Basisgewicht`
};

const pl_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Gramatura`
};

const pt_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Gramagem`
};

const sv_attributes_grammage = /** @type {(inputs: {}) => string} */ () => {
	return `Vikt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_grammage = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_grammage(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_grammage", locale)
	if (locale === "cs") return cs_attributes_grammage(inputs)
	if (locale === "da") return da_attributes_grammage(inputs)
	if (locale === "de") return de_attributes_grammage(inputs)
	if (locale === "en") return en_attributes_grammage(inputs)
	if (locale === "es") return es_attributes_grammage(inputs)
	if (locale === "fr") return fr_attributes_grammage(inputs)
	if (locale === "hu") return hu_attributes_grammage(inputs)
	if (locale === "it") return it_attributes_grammage(inputs)
	if (locale === "nl") return nl_attributes_grammage(inputs)
	if (locale === "pl") return pl_attributes_grammage(inputs)
	if (locale === "pt") return pt_attributes_grammage(inputs)
	return sv_attributes_grammage(inputs)
};
export { attributes_grammage as "attributes.grammage" }